// src/modules/app-views/_apps/appsindico/unitProfiles/pages/Init/components/tableColumns/areaColumn.jsx
// *******************************************************************************
// AREA COLUMN
// *******************************************************************************

import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function areaColumn(buildColumnProps, options = {}) {
  const {
    key = 'area',
    title = 'area_m2',
    dataIndex = 'area',
    width = 100,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: val => (val ? `${val} m²` : '-'),
  };
}

export default areaColumn;
